import { render, staticRenderFns } from "./myinfo-areas.vue?vue&type=template&id=5d255f24&"
import script from "./myinfo-areas.vue?vue&type=script&lang=js&"
export * from "./myinfo-areas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports